import { useState } from 'react'

/**
 * True on the render where `value` differs from the previous one.
 *
 * The "adjusting state when a prop changes" pattern from the React docs, which
 * this folder needs in several places (re-syncing a mask, moving the visible
 * month). Written out by hand it is four lines of latch each time, and the
 * subtlety — that the latch must be updated in the same render, not an effect —
 * is easy to get wrong on the fifth copy.
 */
export function useChanged(value: unknown): boolean {
  const [previous, setPrevious] = useState<unknown>(value)

  if (previous !== value) {
    setPrevious(value)

    return true
  }

  return false
}
